module.exports = "/_next/static/images/btn-campaign-au-pay-b5fe4bf0418b106ef06086bbb4e46e01.png";